<template>
    <GChart
        type="AreaChart"
        :settings="{packages: ['corechart'], language: 'pt-br'}"
        :data="chartDataFinal"
        :options="chartOptions"
    />
</template>

<script>
export default {
    props: ['chartData'],
    data() {
        return {
            chartOptions: {
                fontName: 'Inter',
                height: 400,
                legend: {
                    position: 'top',
                    maxLines: 3
                },
                colors: [
                    '#3cba9f'
                ],
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>

</style>
